import { LayoutModule } from '@angular/cdk/layout';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {
  ApplicationConfig,
  DOCUMENT,
  ErrorHandler,
  importProvidersFrom,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { environment } from '../environments/environment';
import { routes } from './app.routes';
import { RefreshTokenInterceptor } from './shared/anet/auth/refresh-token-interceptor.service';
import { SiteConfigService } from './shared/services/site-config.service';

import { provideAthleticLiveElasticApi, provideAthleticLiveFirebase } from '@athleticnet/athletic-live-api';
import * as Sentry from '@sentry/angular';
import { Observable, of } from 'rxjs';
import packageJson from '../../package.json';
import { provideRouter, withRouterConfig } from '@angular/router';

export function appInitializerFn(
  httpClient: HttpClient,
  siteConfigService: SiteConfigService,
  document: Document,
): () => Observable<any> {
  return () => {
    for (let i = 0, len = environment.siteList.length; i < len; i++) {
      const site = environment.siteList[i];
      if (site.link.indexOf(document.location.origin) > -1) {
        return of(siteConfigService.setConfig(site.machineName));
      }
    }
    return of(siteConfigService.setConfig('athleticlive'));
  };
}

if (environment.production) {
  Sentry.init({
    dsn: 'https://298f73b2bd8e727d6fdbc3bb0f549884@o71191.ingest.us.sentry.io/4507142302990336',
    integrations: [],
    ignoreErrors: [
      '0 Unknown Error',
      'AbortError: Share canceled',
      'Abort due to cancellation of share',
      'Something bad happened; please try again later',
      'Http failure response for https://api.athletic.live/api/notices/my',
      'Cannot redefine property: websredir', // https://spikefalcon.sentry.io/issues/5254578236
    ],
    release: packageJson.version,
  });
}
const a = 6;
export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection(),
    importProvidersFrom(BrowserModule, BrowserAnimationsModule, LayoutModule),
    { provide: ErrorHandler, useValue: Sentry.createErrorHandler() },
    provideRouter(routes, withRouterConfig({ paramsInheritanceStrategy: 'always' })),
    provideAnimations(),
    provideHttpClient(
      withInterceptorsFromDi(),
      //withFetch(),
    ),
    provideAthleticLiveElasticApi({
      searchEndpoint: environment.searchEndpoint,
      elasticEndpoint: environment.elasticEndpoint,
    }),
    provideAthleticLiveFirebase({ config: environment.firebase }),

    provideAppInitializer(() => {
      const initializerFn = appInitializerFn(inject(HttpClient), inject(SiteConfigService), inject(DOCUMENT));
      return initializerFn();
    }),
    { provide: HTTP_INTERCEPTORS, useClass: RefreshTokenInterceptor, multi: true },
  ],
};
